import React from 'react';

/* A function that returns a JSX element. */
export const ContactoMen = (props) => {
	/* Destructuring the props object. */
	const {imagenContacto, nombreContacto, horaUltimoMensaje} = props;

	/* Returning a JSX element. */
	return (
		<div className='contactoMensajes'>
			<div className='imagenContactoMensajes centrador'>
				<img src={imagenContacto} />
			</div>
			<div className='nombreContactoMensajes '>
				<div>{nombreContacto}</div>
			</div>
			<div className='horaContactoMensajes '>
				<div>{horaUltimoMensaje}</div>
			</div>
		</div>
	);
};
